import bgLight from "./assets/images/bg-desktop-light.jpg";
import bgDrak from "./assets/images/bg-desktop-dark.jpg";
import bgLightMobile from "./assets/images/bg-mobile-light.jpg";
import bgDarkMobile from "./assets/images/bg-mobile-dark.jpg";

export const darkTheme = {
    bgImg: bgDrak,
    bgImgMb: bgDarkMobile,
    bg: "#171823",
    todoBg: "#25273D",
    border: "#393A4B",
    color: "#C8CBE7",
    filterColor: "#5B5E7E",
    inputColor: "#C8CBE7",
    completeTodoColor: "#4D5067",
    hover: "#E3E4F1",
    placeholder: "#767992",
    shadow: "none",
};

export const lightTheme = {
    bgImg: bgLight,
    bgImgMb: bgLightMobile,
    bg: "#FAFAFA",
    todoBg: "#fff",
    border: "#E3E4F1",
    color: "#494C6B",
    filterColor: "#9495A5",
    inputColor: "#393A4B",
    completeTodoColor: "#D1D2DA",
    hover: "#494C6B",
    placeholder: "#9495A5",
    shadow: "0px 35px 50px -15px rgba(194, 195, 214, 0.5)",

}
